export default __webpack_public_path__ + "static/media/1334.1290ad76.png";